<template>
  <section class="auth-form">
    <div class="auth-form__container">
      <AuthenticationBackground />
      <div v-show="!isLoading" class="auth-form__wrapper">
        <div class="auth-form__forms">
          <TwoFactorForm
            class="auth-form__form"
            :isLoading="isLoading"
            :isGoogleAuthenticatorMFA="!!isGoogleAuthenticatorMFA"
            @is-digit-code-loading="isDigitCodeLoading"
            @cancel-login="cancelLogin"
            @resend-mfa-code="resendMFACode"
            @handle-submitted-form="handleSubmittedForm"
          />
        </div>
        <AdditionalLinks
          :isTabletFooter="true"
          class="auth-form__form-footer-links"
        />
      </div>
      <Spinner
        v-show="isLoading"
        :label="!isResendingMFACode ? 'You’re being logged in' : ''"
        class="auth-form__wrapper auth-form__spinner"
      />
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { removeAllTokens } from '@internetworkexpert/js-common'
import AuthenticationBackground from '@/components/forms/elements/AuthenticationBackground.vue'
import TwoFactorForm from '@/components/forms/TwoFactorForm.vue'
import AdditionalLinks from '@/components/forms/elements/AdditionalLinks.vue'
import Spinner from '@/components/loaders/LoadingSpinnerV2.vue'

export default {
  name: 'TwoFactor',
  components: {
    AuthenticationBackground,
    TwoFactorForm,
    AdditionalLinks,
    Spinner,
  },
  metaInfo() {
    return {
      title: `INE - Two Factor`,
      meta: [
        {
          vmid: 'robots',
          name: 'robots',
          content: 'noindex',
        },
      ],
    }
  },
  data() {
    return {
      isLoading: false,
      isResendingMFACode: false,
    }
  },
  computed: {
    ...mapState({
      isAuthenticated: state => state.auth.isAuthenticated,
      isTwoFactorRequired: state => state.auth.isTwoFactorRequired,
      searchQuery: state => state.search.searchQuery,
      redirectUrl: state => state.auth.redirectUrl,
      isGoogleAuthenticatorMFA: state => state.auth.isGoogleAuthenticatorMFA,
      businessInvitationId: state => state.business.businessInvitationId,
    }),
  },
  methods: {
    async resendMFACode() {
      this.isLoading = true
      this.isResendingMFACode = true
      await this.$store.dispatch('auth/resendMFACode')
      this.$store.dispatch('app/setNotification', 'The code has been resent.')
      this.isLoading = false
      this.isResendingMFACode = false
    },
    isDigitCodeLoading(value) {
      this.isLoading = value
    },
    async handleSubmittedForm() {
      if (this.isAuthenticated) {
        this.sendMixpanelEvent(this.eventsConstants.ACCOUNT_USER_LOGIN, {})
        if (this.businessInvitationId) {
          return this.$router.push({
            name: 'confirm-invite',
            params: { id: this.businessInvitationId },
          })
        }
        if (this.redirectUrl && this.redirectUrl.length) {
          window.location.assign(this.redirectUrl)
        } else {
          this.$router.push({ name: 'home' })
        }
      }
    },
    async cancelLogin() {
      await removeAllTokens()
      this.$store.dispatch('auth/setIsTwoFactorRequired', false)
      this.$store.dispatch('auth/setRedirectUrl', '')
      this.$router.push({ name: 'home' })
    },
  },
  async created() {
    if (!this.isTwoFactorRequired) {
      this.$router.push({ name: 'login' })
      this.$store.dispatch('auth/setIsTwoFactorRequired', false)
    }
  },
}
</script>
